import { KeyedStreamItem } from 'communication/types/StreamElement';
import { StreamMessage } from 'utils/messages/StreamMessage';
import { WidgetStreamMessagesState } from 'widgets/store/stream/WidgetStreamState';

export interface SymbolTilesStreamState extends WidgetStreamMessagesState {
    data: SymbolStateDictionary;
}

export type SymbolStateDictionary = {
    [symbol: string]: SymbolTilesSymbolState;
};

export interface SymbolTilesSymbolState {
    messages: StreamMessage[];
    pnc: number;
    currency: string;
    tickSize?: number;
    bid: number;
    ask: number;
    lastTradePrice: number;
    lastTradePriceChange?: number;
    lastTradePriceChangePercent?: number;
    bars: SymbolTilesSymbolBarItem[];
}

export const initialSymbolTilesSymbolState: SymbolTilesSymbolState = {
    messages: [],
    pnc: 0,
    currency: '',
    bid: 0,
    ask: 0,
    lastTradePrice: 0,
    bars: [],
};

export interface SymbolTilesSymbolBarItem extends KeyedStreamItem {
    closePrice: number;
    percentChange: number;
    high: number;
    low: number;
}

export const initialSymbolTilesSymbolBarItem: SymbolTilesSymbolBarItem = {
    closePrice: 0,
    percentChange: 0,
    high: 0,
    low: 0,
    _i: 0,
};

export const initialSymbolTilesStreamState: SymbolTilesStreamState = {
    data: {},
    messages: [],
};
